#import "~/graphql/fragments/Comment.graphql"

mutation CreateComment(
    $text: String!
    $videoId: ID!
    $commentId: ID
) {
    createComment(
        text: $text
        video_id: $videoId
        comment_id: $commentId
    ) {
        ...Comment
    }
}
